
import { api, nonauthapi } from './api';
import download from 'downloadjs';
import { API_BASE_URL, ACCESS_TOKEN} from '../constants';
export const logout = async (logoutRequest) => await api.post("/user/logout", logoutRequest);

export const login = async (loginRequest) => {
    try {
        let response = await nonauthapi.post("/auth/login", loginRequest)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };
}

export const getCurrentUser = async () => {

    try {
        let response = await api.get("/user/me");
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };
}
export const signup = async (signupRequest) => {
    try {
        let response = await nonauthapi.post("/auth/register", signupRequest)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const resetpasswordreq = async (resetRequest) => {
    try {
        let response = await nonauthapi.post("/auth/password/reset", resetRequest)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const resetpasswordlink = async (signupRequest) => {
    try {
        let response = await nonauthapi.post("/auth/password/resetlink", signupRequest)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const checkUsernameAvailability = async (username) => {
    try {
        let response = await nonauthapi.get("/auth/checkUsernameInUse?username=" + username)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const checkEmailAvailability = async (email) => {
    try {
        let response = await nonauthapi.get("/auth/checkEmailInUse?email=" + email)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}


export const registrationConfirmation = async (token) => {
    try {
        let response = await nonauthapi.get("/auth/registrationConfirmation?token=" + token)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const checkTokenAvailability = async (token) => {
    try {
        let response = await nonauthapi.get("/auth/checkTokenInUse?token=" + token)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}

export const getUserProfile = async () => {
    try {
        let response = await api.get("/user/profile")
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const getFlat = async () => {
    try {
        let response = await api.get("/user/flats")
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };

}
export const getCounter = async (flat) => {

    try {
        let response = await api.get("/user/counter?flat=" + flat)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}


export const setCountVal = async (Request) => {
    try {
        let response = await api.post("/user/countervalue", Request)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };
}

export const getQRCoge = async (Request) => {
    try {
        let response = await api.post("/user/qrcode", Request)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };
}
export const resend = async (token)=> {
        try {
        let response = await nonauthapi.get("/auth/resendRegistrationToken" + token)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    };
}
export const profileset = async (Request) => {
    try {
        let response = await api.post("/user/profileset", Request)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const addtoken = async (token) => {
    try {
        let response = await api.get("/user/addtoken?token=" + token)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const resendRegistrationToken =  async (token)=> {
        try {
        let response = await nonauthapi.get("/auth/resendRegistrationToken?token=" + token)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const getAmount = async (Request) => {
    try {
        let response = await api.post("/user/amount", Request)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
export const getReport = async (Request) => {
    return downloadFile(Request);

}
export const getMailReport = async (Request)=> {
        try {
        let response = await api.post("/user/mailreport", Request)
        return response.data;
    } catch (error) {
        return Promise.reject(error.response);
    }
}
let fnGetFileNameFromContentDispostionHeader = function (header) {
    let contentDispostion = header.split(';');
    const fileNameToken = `filename*=UTF-8''`;
    let fileName = 'downloaded.pdf';
    for (let thisValue of contentDispostion) {
        if (thisValue.trim().indexOf(fileNameToken) === 0) {
            fileName = decodeURIComponent(thisValue.trim().replace(fileNameToken, ''));
            break;
        }
    }

    return fileName;
};
const downloadFile = async (Request) => {
    try {
        const response = await api.post("/user/report", Request, {
            responseType: 'blob',
        });

        const resObj = ({
            filename: fnGetFileNameFromContentDispostionHeader(response.headers.get('content-disposition')),
            filetype: response.headers.get('Content-Type'),
            blob: response.data
        });
        download(resObj.blob, resObj.filename, resObj.filetype);

    } catch (error) {
        console.error('Error downloading file:', error);
    }
};
export function makePayment3(Request) {
    return request2({
        url: API_BASE_URL + "/user/payorder",
        method: 'POST',
        body: JSON.stringify(Request)
    });
    
}
const request2 = async (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })
    
 //   if (localStorage.getItem(EXPIRATION)&&
 //   localStorage.getItem(EXPIRATION)<Date.now()){
 //       console.log('Token expired. Refresh need');
 //   }


    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }
    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);
    // console.log('HTTP request:  ', options.url);
    await fetch(options.url, options)
    .then(response=>response.text().then(data=>{
        if(!response.ok) { return Promise.reject(data); }
        const parser = new DOMParser();
        const xmlDOM = parser.parseFromString(data,"text/xml");
        const value = xmlDOM.getElementsByTagName("redirect")[0].childNodes[0].nodeValue;
        console.log(value);
        window.location.replace(value)
    }))
    .catch(err=>{console.log("Utils1: ",err);
        return Promise.reject(err)})
    
};